// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1811":"00c25d06","5154":"d0aaa46c","7613":"c53cd375","9341":"00c25d06"}[chunkId] + ".chunk.css";
};